<template>
  <div class="answer_list">
    <ul>
      <li v-for="(item, index) in questionData" :key="index">
        <div class="answer_top">
          <div class="interupt" @click="getLiveInfo(item.data.id, item.data.showLiveLi, item.data.answerName, item)">
            <div class="title">
              <div class="title_left" v-show="!item.data.showLiveLi">{{ item.data.topicName }}</div>
              <div class="title_left" v-show="item.data.showLiveLi">{{ item.data.answerName }}</div>
              <div class="title_right" :class="[{ 'ing': item.data.status == 1 },
              { 'future': item.data.status == 0 }, { 'ever': item.data.status == 2 }]">
                <i></i>
                <span>{{ item.data.status | filterText }}</span>
              </div>
            </div>
            <div class="live_img" v-show="item.data.showLiveLi">
              <img class="big_img" :src="item.data.simpleChineseLogo" alt />
              <div class="answer_person">
                <div class="news-title" v-show="item.data.status == 1">
                  <img src="https://sc.cfygxz.com/source/public/avatar/15.png" />
                  <img src="https://sc.cfygxz.com/source/public/avatar/27.png" />
                  <img src="https://sc.cfygxz.com/source/public/avatar/12.png" />
                  <span>{{ item.data.totalViewNum }}</span>人正在参与讨论
                </div>
                <div class="news-time">
                  {{ item.data.answerDate | filterDate }} {{ item.data.startTime }}
                  ~{{ item.data.endTime }}
                </div>
              </div>
            </div>
            <div class="answer_bottom" v-show="!item.data.showLiveLi">
              <div class="view_left">
                <div class="view_item1">
                  <span>{{ item.data.totalViews }}</span>浏览
                </div>
                <div class>
                  <span>{{ item.data.totalComment }}</span>讨论
                </div>
              </div>
              <div class="view_right">{{ item.data.startDate }}</div>
            </div>
          </div>

          <div class="product_list">
            <ul>
              <li 
                v-for="(itemPro, index) in item.pro"
                :key="index"
                :class="[{ 'red': itemPro.class == 'red' }, { 'green': itemPro.class == 'green' }]"
                @click="goMarket(itemPro.symbol)">
                <span>{{ itemPro.name }}</span>
                <span style="margin:0 .1rem;">{{ itemPro.price }}</span>
                <span>{{ itemPro.val }}</span>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import user from "assets/commonjs/userInfo";
import { toast } from "assets/commonjs/toast";
import { getStore } from "assets/commonjs/storage";
export default {
  data() {
    return {
      questionData: [],
      companyId: 1,
      tradeUrl: process.env.VUE_APP_H5_TRADE,

    };
  },
  props: ["hotQuestion", 'symbolMap'],

  watch: {
    hotQuestion: {
      handler(val) {
        if (Object.keys(val).length > 0) {
          for (let i in val) {
            if (val[i].dataType == 1) {
              val[i].data.showLiveLi = true;
            } else {
              val[i].data.showLiveLi = false;
            }
            let arr = [];
            if (val[i].data.productCode != "") {
              let codes = val[i].data.productCode.split(",");
              for (let i in codes) {
                if (this.symbolMap != undefined) {
                  if (this.symbolMap[codes[i]] != null && this.symbolMap[codes[i]] != undefined) {
                    arr.push(this.symbolMap[codes[i]]);
                  }
                }


              }
            }
            let data = this.getAllSymbalData(arr);
            this.$set(val[i], "pro", data);
          }
        }
        this.questionData = val;
      },
      immediate: true
    }
  },
  methods: {

    getLiveInfo(id, liveLabel, name) {
      let data = {
        liveId: id,
        companyId: this.companyId
      };
      this.$api.answerList.queryLive(data).then(res => {
        if (liveLabel == true) {
          if (res.data.code == 0) {
            if (res.data.result.status == 0) {
              toast("该实时问答还未开始，敬请关注");
            } else {
              this.$router.push({
                path: "/chatDetail",
                query: {
                  liveId: id,
                  liveName: name,
                  status: res.data.result.status
                }
              });
            }
          }
        } else {
          this.addView(id);
        }
      });
    },
    getAllSymbalData(res) {
      let productPramas = [];
      let ampClass, ampValue, ampName, ampPrice, symbol;
      if (res) {
        let data = res;
        for (let i in data) {
          if (getStore('patternLabel') == "redGreen" || getStore('patternLabel') == undefined) {
            if (data[i].amplitude > 0) {
              ampClass = "red"
            } else {
              ampClass = "green"
            }
          } else {
            if (data[i].amplitude > 0) {
              ampClass = "green"
            } else {
              ampClass = "red"
            }
          }
          if (data[i].amplitude) {
            ampValue = this.percent(data[i].amplitude);
          } else if (data[i].amplitude == 0) {
            ampClass = "";
            ampValue = 0;
          }
          ampName = data[i].name;
          ampPrice = data[i].price;
          symbol = data[i].symbol;
          productPramas.push({
            class: ampClass,
            val: ampValue,
            name: ampName,
            price: ampPrice,
            symbol: symbol
          });
        }
      }

      return productPramas;
    },
    getProductData(code) {
      let productPramas = [];

      this.$api.strageList.getProductData(code).then(res => {
        let ampClass, ampValue, ampName, ampPrice, symbol;
        if (res.data) {
          let data = res.data;
          for (let i in data) {
            if (data[i].amplitude) {
              ampClass = data[i].amplitude > 0 ? "red" : "green";
              ampValue = this.percent(data[i].amplitude);
            } else if (data[i].amplitude == 0) {
              ampClass = "";
              ampValue = 0;
            }
            ampName = data[i].name;
            ampPrice = data[i].price;
            symbol = data[i].symbol;
            productPramas.push({
              class: ampClass,
              val: ampValue,
              name: ampName,
              price: ampPrice,
              symbol: symbol
            });
          }
        }
      });

      return productPramas;
    },
    percent: function (value) {
      if (!value) return "";
      value = Number(value * 100).toFixed(2);
      value += "%";
      return value;
    },
    goMarket(symbol) {
      user.goTrade(symbol);
    },

    addView(id) {
      let data = {
        id: id,
        count: 1,
        companyId: this.companyId
      };
      this.$api.strageList.addView(data).then(res => {
        if (res.data && res.data.code == 0) {
          this.$router.push({ path: 'questionDetail', query: { id: id } });

        }
      });
    }
  },
  filters: {
    filterText(val) {
      if (val == 0) {
        return "未开始";
      } else if (val == 1) {
        return "进行中";
      } else {
        return "已结束";
      }
    },
    filterDate(val) {
      if (!val) return;
      return val.substring(5);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~assets/styles/mixin";

.answer_list {
  ul {
    li {
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.15);
      border-radius: 0.1rem;
      margin-bottom: 0.3rem;

      .answer_top {
        .interupt {
          padding: 0.4rem 0.2rem 0;
          border-bottom: 0.025rem solid #ebebeb;
        }

        .title {
          display: flex;
          justify-content: space-between;

          .title_left {
            @include sc(0.32rem, #333);
            width: 5.3rem;
            text-align: justify;
            position: relative;
          }

          .title_right {
            i {
              display: inline-block;
              vertical-align: middle;
              @include wh(0.22rem, 0.22rem);
              @include bis("~assets/images/icon-sprite.png", 3.34rem, 3.2rem);
              margin-right: 0.1rem;
            }

            span {
              vertical-align: middle;
            }

            @include sc(0.24rem, #e7a70c);
          }

          .title_right.ing {
            i {
              @include bp(-3.02rem, -0.52rem);
            }

            color: #e7a70c;
          }

          .title_right.future {
            i {
              @include bp(-3.02rem, -0.1rem);
            }

            color: #788bb6;
          }

          .title_right.ever {
            i {
              @include bp(-3.02rem, -0.94rem);
            }

            color: #c1bebe;
          }
        }

        .product_list {
          ul {
            @include fj();
            padding: 0.2rem;
            display: grid; 
            grid-template-columns: repeat(2, 1fr);
            gap: 0.2rem; 
            list-style-type: none;
            padding: 0.2rem;

            li {
              @include wh(auto, 0.42rem);
              line-height: 0.42rem;
              border-radius: 0.06rem;
              background: #51b64c;
              text-align: center;
              font-size: 0;
              box-shadow: none;
              padding: 0 .2rem;
              margin: 0;

              span {
                @include sc(0.2rem, #fff);
              }
            }

            li.green {
              background: #51b64c;
            }

            li.red {
              background: #fb605a;
            }
          }
        }
      }

      .answer_bottom {
        @include fj();
        @include sc(0.24rem, #999);
        padding: 0.23rem 0;

        .view_left {
          @include fj();

          .view_item1 {
            margin-right: 0.5rem;
          }
        }
      }

      .live_img {
        padding: 0.2rem 0;

        .big_img {
          width: 6.5rem;
          height: 2.36rem;
          border-radius: 0.1rem;
        }

        .answer_person {
          @include fj();

          .news-title {
            font-size: 0.24rem;
            color: #333;

            img {
              display: inline-block;
              width: 0.34rem;
              vertical-align: middle;
              margin-right: 0.05rem;
            }
          }

          .news-time {
            @include sc(0.24rem, #999);
          }
        }
      }
    }
  }
}
</style>